import { render } from "./AppStoreTable.vue?vue&type=template&id=3ef5a925"
import script from "./AppStoreTable.vue?vue&type=script&lang=js"
export * from "./AppStoreTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/davidchou/Documents/Programming/vue/cvicloud-app-states-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__